import React, { useState, useEffect, useRef } from "react";
import UserService from "../services/UserService";
import { Button } from 'primereact/button';
import { TextField } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';


export default function EmailOverride({ userId }) {
  const [editingMode, setEditingMode] = useState(false);
  const [override, setOverride] = useState(null);
  const [email, setEmail] = useState(null);
  const [changed, setChanged] = useState(false);
  const [valid, setValid] = useState(false);
  const [loading, setLoading] = useState(true);

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const onSaveButton = () => {
    new UserService().setEmailOverride(userId, email)
      .then((data) => {
        setChanged(false);
        setOverride(email);
        setEditingMode(false);
      });
  };

  useEffect(() => {
    if (userId) {
      setLoading(true)
      new UserService().getEmailOverride(userId)
        .then((data) => {
          setOverride(data['email'] || "");
          setEmail(data['email'] || "");
          setLoading(false);
        });
    }
  }, [userId]);

  if (loading) return null;
  if (!override && !editingMode) {
    return <Button label="Configure Email Override" className="p-button-outlined" onClick={()=>{setEditingMode(true); }}/>;
  }

  return (
    <Grid container spacing={3}>
        <Grid item xs={10} sm={10}>
          <TextField
            onChange={(e) => {
              let email=e.target.value.toLowerCase().replace(/\s/g, '');
              setEmail(email);
              setChanged(true);
              setValid(validateEmail(email));
            }}
            //style = {{width: 200}} 
            fullWidth
            label="Email Override"
            value={email}
            disabled={!editingMode}
            InputLabelProps={{ shrink: true }}
            inputRef={(input) => {if (input != null) {input.focus()}}}
          />
        </Grid>
        <Grid item xs={2} sm={2}>
          {!editingMode && <Button icon="pi pi-user-edit" className="p-button-rounded p-button-text p-button-plain" onClick={()=>{setEditingMode(true);}}/>}

          {changed && valid && <Button label="Save" icon="pi pi-check" className="p-button-rounded p-button-text" onClick={onSaveButton}/>}
          {changed && valid&& <Button label="Cancel" icon="pi pi-times" className="p-button-rounded p-button-text" onClick={()=>{setEmail(override); setChanged(false)}}/>}
        </Grid>
      </Grid>
  );
}
